import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
  Box, Card, CardContent, TextField, Button, Typography, CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { colorPalette } from "&config/colors";
import { RootState } from "&store/store";
import { loginActions } from "&features/login/login.slice";
import { twoFactorActions } from "./twoFactor.slice";

type ReduxProps = ConnectedProps<typeof connector>;

const VerifyTwoFactorComponent = (props: ReduxProps) => {
  const { token, verifyOtp, setLoginToken, resetLogin, setTwoFactorPending } = props;
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid 6-digit code", { position: "top-center" });
      return;
    }
    setLoading(true);
    const { payload }: any = await verifyOtp({ otp, token: token as string });
    setLoading(false);
    if (payload?.token) {
      setLoginToken(payload.token);
      setTwoFactorPending(false);
      window.location.href = "/dashboard";
    }
  };

  const handleBack = () => {
    resetLogin();
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: colorPalette.primary,
      }}
    >
      <Card sx={{ padding: "2rem", borderRadius: "19px", width: "441px" }}>
        <CardContent>
          <Box sx={{ textAlign: "center", marginBottom: "2rem" }}>
            <Typography variant="h5" fontWeight="bold" color={colorPalette.primary}>
              Two-Factor Authentication
            </Typography>
            <Typography variant="body2" sx={{ color: "#666", marginTop: "0.5rem" }}>
              Open Google Authenticator and enter the 6-digit code for this account.
            </Typography>
          </Box>

          <TextField
            fullWidth
            label="Authentication Code"
            placeholder="000000"
            value={otp}
            onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
            inputProps={{ maxLength: 6 }}
            sx={{ marginBottom: "1.5rem" }}
          />

          <Button
            fullWidth
            variant="contained"
            disabled={loading}
            onClick={handleVerify}
            sx={{ marginBottom: "1rem", fontWeight: "bold", background: colorPalette.primary }}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : "VERIFY"}
          </Button>

          <Button fullWidth variant="text" onClick={handleBack} sx={{ color: "#666" }}>
            Back to Login
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.login.token,
});

const mapDispatchToProps = {
  verifyOtp: twoFactorActions.verifyLoginOtp,
  setLoginToken: (token: string) => loginActions.setLogin({ token, isTwoFactor: true }),
  setTwoFactorPending: twoFactorActions.setTwoFactorPending,
  resetLogin: loginActions.reset,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const VerifyTwoFactorRedux = connector(VerifyTwoFactorComponent);
export { VerifyTwoFactorRedux as VerifyTwoFactorComponent };
